<template>
  <v-empty-state icon="mdi-alert-circle-outline" color="error">
    <template #headline>Error</template>
    <template #title> Server nicht erreichbar </template>
    <template #text>
      <span>
        Bitte versuchen Sie es später wieder oder kontaktieren Sie uns unter
        <a href="mailto:s.latkovic@brelag.com">s.latkovic@brelag.com</a>.
      </span>
    </template>
    <!-- Footer -->
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>STYLER</strong> by
          <a href="https://brelag.com/">Brelag Schweiz AG</a>.
        </p>
      </div>
    </footer>
  </v-empty-state>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
ul {
  padding: inherit;
  list-style: inherit;
}
</style>
